import { Reveal, SectionHeader } from "@/components/site/Reveal";
import { PROCESS_ICONS } from "@/data/content";
import { useLanguage } from "@/i18n/LanguageContext";

export const Process = () => {
    const { t } = useLanguage();

    return (
        <section id="process" className="relative py-24 md:py-32" data-testid="process-section">
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <SectionHeader
                    number={t.process.number}
                    label={t.process.label}
                    title={t.process.title}
                    description={t.process.description}
                />
                <div className="relative border-l border-white/10 ml-4 md:ml-6 pl-8 md:pl-12 space-y-12">
                    {t.process.steps.map((step, i) => {
                        const Icon = PROCESS_ICONS[i];
                        const stepLabel = t.process.stepTemplate.replace("{n}", String(i + 1).padStart(2, "0"));
                        return (
                            <Reveal key={step.title} delay={i * 0.08}>
                                <div className="relative" data-testid={`process-step-${i}`}>
                                    <span className="absolute -left-[41px] md:-left-[57px] top-1 flex h-5 w-5 items-center justify-center">
                                        <span className="absolute h-5 w-5 rounded-full bg-cyan-400/20 animate-pulse-glow" />
                                        <span className="relative h-2.5 w-2.5 rounded-full bg-cyan-400 shadow-[0_0_12px_rgba(0,210,255,0.8)]" />
                                    </span>
                                    <div className="group glass-card glass-card-hover rounded-2xl p-6 md:p-8 transition-transform duration-500 hover:-translate-y-1 md:max-w-3xl">
                                        <div className="flex items-start gap-5">
                                            <div className="shrink-0 rounded-xl border border-cyan-400/20 bg-gradient-to-br from-cyan-400/15 to-[#3A7BD5]/10 p-3 transition-transform duration-500 group-hover:scale-110 group-hover:rotate-3">
                                                <Icon className="h-6 w-6 text-cyan-400" strokeWidth={1.5} />
                                            </div>
                                            <div>
                                                <p className="font-mono text-xs uppercase tracking-[0.25em] text-cyan-400/70 mb-1.5">
                                                    {stepLabel}
                                                </p>
                                                <h3 className="font-display text-xl md:text-2xl font-bold text-white mb-2">
                                                    {step.title}
                                                </h3>
                                                <p className="text-sm md:text-base text-zinc-400 leading-relaxed font-light">
                                                    {step.description}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Reveal>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};
